// Convert a public link URL like `https://trackmatrix.net/r/<slug>` into the
// shareable preview URL `https://trackmatrix.net/api/p/<slug>` that returns
// rich Open Graph meta tags (thumbnail + title) when scraped by WhatsApp /
// Facebook / iMessage. Real shoppers still get redirected through to the
// destination — the preview URL is just a SEO-friendly wrapper around /r/.
//
// We don't blindly string-replace because:
//  - the input might be malformed
//  - we want to preserve any query params (e.g. ?p=<product_id>)
// Returns the original URL unchanged if it doesn't look like a /r/<slug> URL.
export function toPreviewShareUrl(publicUrl) {
  if (!publicUrl || typeof publicUrl !== "string") return publicUrl;
  try {
    const u = new URL(publicUrl);
    // Match /r/<slug>[/...]
    const m = u.pathname.match(/^\/r\/([^/]+)(\/.*)?$/);
    if (!m) return publicUrl;
    u.pathname = `/api/p/${m[1]}${m[2] || ""}`;
    return u.toString();
  } catch {
    return publicUrl;
  }
}
